export default __webpack_public_path__ + "static/media/fridge2-beforeA-1920w.27011087.webp";